const PermissionEnum = {
    Gaau: {
        Adicionar: "Gaau.Adicionar",
        Visualizar: "Gaau.Visualizar",
        Remover: "Gaau.Remover",
        Editar: "Gaau.Editar",
        ImagemRemover: "Gaau.Imagem.Remover",
        AdicionarHistorico: "Gaau.Adicionar.Historico"
    },
    DynamicForm: {
        Adicionar: "DynamicForm.Adicionar",
        Visualizar: "DynamicForm.Visualizar",
        Remover: "DynamicForm.Remover",
        Editar: "DynamicForm.Editar"
    },
    Equipe: {
        Adicionar: "Equipe.Adicionar",
        Visualizar: "Equipe.Visualizar",
        Remover: "Equipe.Remover",
        Editar: "Equipe.Editar"
    },
    OrdemServico: {
        Adicionar: "OrdemServico.Adicionar",
        Visualizar: "OrdemServico.Visualizar",
        Remover: "OrdemServico.Remover",
        Editar: "OrdemServico.Editar",
        Executar: "OrdemServico.Executar"
    },
    GeoPortal: {
        Visualizar: "GeoPortal.Visualizar"
    },

};

export default PermissionEnum;
